export default __webpack_public_path__ + "locales/ja-JP/Webhooks.json?hash=a4a4ed4ab520a3902bd8e809fa20d9fd";